import { EventTypes } from './enums/event-types';

export const pushEvent = (
  event: EventTypes,
  payload: Record<string, any> = {}
) => {
  window &&
    (window as any).dataLayer &&
    (window as any).dataLayer.push({ event, ...payload });
};
